module.exports = __webpack_public_path__ + "media/buy-now/sample_box3-11c4f422.png";